const SESSION_KEY = "session";
const AUTH_TOKEN_KEY = "jwt";

/**
 * getCookie
 * @param {String} name : the name of a cookie to retrieve a value for
 */
export function getCookie(name) {
	var value = "; " + document.cookie;
	var parts = value.split("; " + name + "=");
	if (parts.length === 2)
		return parts
			.pop()
			.split(";")
			.shift();
}

export function getSession() {
	return getCookie(SESSION_KEY);
}

export function getAuthToken() {
	return getCookie(AUTH_TOKEN_KEY);
}
